import React from 'react'
import { withProps, compose } from 'recompose'
import { withScriptjs } from 'react-google-maps'

import { GOOGLE_API_KEY } from 'utils/constants'

interface IProps {
  geo: any
  containerElement: any
  mapElement: any
  onMarkerClicked: any
  Map: any
  type:any
  geoZoneSelected : any
}

const _Map = ({ geo, containerElement, mapElement, onMarkerClicked, Map,type, geoZoneSelected }: IProps) => (
  <Map geo={geo} containerElement={containerElement} mapElement={mapElement} type={type} onMarkerClicked={onMarkerClicked} geoZoneSelected={geoZoneSelected} />
)

export default compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: '100%' }} />,
    containerElement: <div style={{ height: '400px' }} />,
    mapElement: <div style={{ height: '100%' }} />,
  }),
  withScriptjs,
)(_Map)

